import React from 'react';
import { useNavigate } from 'react-router-dom';

import { changeDateFormat } from '@utils/Util';

const SampleRequest = ({ dataItem }) => {
	const navigate = useNavigate();
	const renderActivityCountList = () => {
		return dataItem?.activityCountList?.map((item) => {
			return (
				item?.count > 0 && (
					<span key={`request_activity_${item?.activity}`} className="status">
						{item?.activity}
						<span>{item?.count}</span>
					</span>
				)
			);
		});
	};

	let docs = dataItem.productDocuments ? dataItem.productDocuments : [];

	return (
		<div className="sample-single-item all-samples" key={`sample_single_item_${dataItem.id}`}>
			<div className="container-fluid">
				<div className="row">
					<div
						onClick={() => navigate(`/sample/view/${dataItem.id}`)}
						className="col-sm-12 col-md-6 col-lg-6 col-xl-4 one-sixth pl-0"
					>
						<div className="d-flex align-items-center">
							<div className="product-img-container">
								<div className="prev-img">
									{docs.length ? (
										<img src={docs[0]} alt="" />
									) : (
										<img
											src={`${process.env.PUBLIC_URL}/images/default_product.svg`}
											alt=""
										/>
									)}
								</div>
								<div className="prev-img-thumb">
									{docs.length > 1 ? (
										<div className="single-first">
											<img src={docs[1]} alt="" />
										</div>
									) : (
										<div className="single-first">
											<img
												src={`${process.env.PUBLIC_URL}/images/default_product.svg`}
												alt=""
											/>
										</div>
									)}
									{docs.length > 2 ? (
										<div className="single-second">
											<img src={docs[2]} alt="" />
										</div>
									) : (
										<div className="single-second">
											<img
												src={`${process.env.PUBLIC_URL}/images/default_product.svg`}
												alt=""
											/>
										</div>
									)}
								</div>
							</div>
							<div className="contents pl-3">
								<p className="medium-14 gray_dark_01 mb-1">
									{dataItem?.title || dataItem?.collectionName}
								</p>
								<ul className="common-list-component mb-2">
									<li className="gray_dark_01 weight-500">{dataItem?.requestedBy}</li>
									<li>{dataItem?.refNo}</li>
									<li>{dataItem?.unitResponseList?.map((obj) => obj?.name).join(', ')}</li>
								</ul>
								<span className="brand-common-design">{dataItem?.brand}</span>
								{!dataItem.isViewed && <span className="new-tag">NEW</span>}
							</div>
						</div>
					</div>
					<div
						onClick={() => navigate(`/sample/view/${dataItem.id}`)}
						className="col-sm-8 col-md-5 col-lg-6 col-xl-4 one-sixth request-info-date-details"
					>
						<div className="d-flex justify-content-center after-boder">
							<div
								onClick={() => navigate(`/sample/view/${dataItem.id}`)}
								className="mr-4 sample-qty-info"
							>
								<p className="regular-12 gray_dark_02">
									<span className="gray_dark_01 weight-500">
										<span className="font-weight-normal gray_dark_02 info-label">
											Design
										</span>
										{dataItem?.noOfDesign}
									</span>
								</p>
								<p className="regular-12 gray_dark_02">
									<span className="info-label"> Size</span>
									<span className="gray_dark_01 weight-500">{dataItem?.noOfSize}</span>
								</p>
								<p className="regular-12 gray_dark_02">
									<span className="info-label"> Pcs</span>
									<span className="gray_dark_01 weight-500">{dataItem?.quantity}</span>
								</p>
							</div>
							<div className="expected-dates ml-1">
								{dataItem?.requestedDate && (
									<p className="regular-12 gray_dark_02">
										<span>Requested</span>
										<span className="gray_dark_01 ml-2">
											{changeDateFormat(
												dataItem?.requestedDate,
												'YYYY-MM-DD',
												'DD MMM, YYYY'
											)}
										</span>
									</p>
								)}
								{dataItem?.requireDate && (
									<p className="regular-12 gray_dark_02">
										<span>Required</span>
										<span className="gray_dark_01 ml-2">
											{changeDateFormat(
												dataItem?.requireDate,
												'YYYY-MM-DD',
												'DD MMM, YYYY'
											)}
										</span>
									</p>
								)}
								{dataItem?.deliveryDate && (
									<p className="regular-12 gray_dark_02">
										<span>ETD</span>
										<span className="secondary ml-2">
											{changeDateFormat(
												dataItem?.deliveryDate,
												'YYYY-MM-DD',
												'DD MMM, YYYY'
											)}
										</span>
									</p>
								)}
							</div>
						</div>
					</div>

					<div
						onClick={() => navigate(`/sample/view/${dataItem.id}`)}
						className="col-sm-4 col-md-12 col-lg-12 col-xl-4 one-sixth"
					>
						<div className="sample-status">{renderActivityCountList()}</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default SampleRequest;
